/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { forwardRef } from "react";

export type AccordionTriggerProps = AccordionPrimitive.AccordionTriggerProps;

export const AccordionTrigger = forwardRef<any, AccordionTriggerProps>(({ ...props }, forwardedRef) => (
	<AccordionPrimitive.Trigger {...props} ref={forwardedRef} />
));

AccordionTrigger.displayName = "Accordion.Trigger";
